module.exports = __webpack_public_path__ + "img/gallery_p.a6483912.svg";